import alt from 'alt'
import axios from 'axios'
import { API_BASE } from 'consts'

const ExtendedUserSource = {
  fetchCurrent: function(token) {
    const instance = axios.create({
      headers: { 'Authorization': token }
    })

    return instance.post(`${API_BASE}/users/current`)
      .then(res => res.data)
  },

  update: function(params) {
    return axios.put(`${API_BASE}/users/current`, {
      user: params
    }).then(res => res.data)
  },
}

// const ExtendedUserSources = {
//   signUp: {
//     remote(state, data) {
//       return axios.post(`${API_BASE}/signups`, {
//         user: {...data}
//       }).then(res => res.data)
//     },
//
//     loading: UserActions.signUp,
//     success: UserActions.signedUp,
//     error:   UserActions.signUpFailed
//   },
//
//   logIn: {
//     remote(state, data) {
//       return axios.post(`${API_BASE}/users/sign_in`, {
//         user: {...data}
//       }).then(res => res.data)
//     },
//
//     loading: UserActions.signIn,
//     success: UserActions.signedIn,
//     error:   UserActions.signInFailed
//   },
//
//   fetchCurrent: {
//     remote(state, token) {
//       const instance = axios.create({
//         headers: {'Authorization': token}
//       })
//
//       return instance.post(`${API_BASE}/users/current`)
//       .then(res => res.data)
//     },
//
//     success: UserActions.currentFetched,
//     error:   UserActions.currentFailed
//   },
// }

export default ExtendedUserSource



// WEBPACK FOOTER //
// ./app/sources/ExtendedUserSource.js